import { memo } from '@wordpress/element';
import { __ } from '@wordpress/i18n';
export const LibraryIcon = () => (
	<svg
		xmlns="http://www.w3.org/2000/svg"
		width="24"
		height="24"
		viewBox="0 0 24 24"
		fill="currentColor"
	>
		<g clipPath="url(#clip0_20469_155509)">
			<path
				d="M3.43322e-05 14.6971C3.43322e-05 13.8686 0.671606 13.1971 1.50003 13.1971L9.30002 13.1971C10.1284 13.1971 10.8 13.8686 10.8 14.6971L10.8 22.4971C10.8 23.3255 10.1284 23.9971 9.30002 23.9971H1.50003C0.671606 23.9971 3.43322e-05 23.3255 3.43322e-05 22.4971L3.43322e-05 14.6971Z"
				fill="currentColor"
			/>
			<path
				d="M13.2 5.39707C13.2 2.41473 15.6177 -0.00292969 18.6 -0.00292969C21.5823 -0.00292969 24 2.41473 24 5.39707C24 8.37941 21.5823 10.7971 18.6 10.7971C15.6177 10.7971 13.2 8.37941 13.2 5.39707Z"
				fill="currentColor"
			/>
			<path
				d="M0 1.49707C0 0.668643 0.671572 -0.00292969 1.5 -0.00292969L9.29999 -0.00292969C10.1284 -0.00292969 10.8 0.668643 10.8 1.49707L10.8 9.29707C10.8 10.1255 10.1284 10.7971 9.29999 10.7971L1.5 10.7971C0.671572 10.7971 0 10.1255 0 9.29707L0 1.49707Z"
				fill="currentColor"
			/>
			<path
				d="M13.2 14.7971C13.2 14.3553 13.5582 13.9971 14 13.9971L23.2 13.9971C23.6418 13.9971 24 14.3553 24 14.7971C24 15.2389 23.6418 15.5971 23.2 15.5971L14 15.5971C13.5582 15.5971 13.2 15.2389 13.2 14.7971Z"
				fill="currentColor"
			/>
			<path
				d="M13.2 18.6051C13.2 18.1633 13.5582 17.8051 14 17.8051H23.2C23.6418 17.8051 24 18.1633 24 18.6051C24 19.0469 23.6418 19.4051 23.2 19.4051H14C13.5582 19.4051 13.2 19.0469 13.2 18.6051Z"
				fill="currentColor"
			/>
			<path
				d="M13.2 22.4131C13.2 21.9713 13.5582 21.6131 14 21.6131H23.2C23.6418 21.6131 24 21.9713 24 22.4131C24 22.8549 23.6418 23.2131 23.2 23.2131H14C13.5582 23.2131 13.2 22.8549 13.2 22.4131Z"
				fill="currentColor"
			/>
		</g>
		<defs>
			<clipPath id="clip0_20469_155509">
				<rect width="24" height="24" fill="currentColor" />
			</clipPath>
		</defs>
	</svg>
);

export const CloseIcon = () => (
	<svg
		xmlns="http://www.w3.org/2000/svg"
		width="13"
		height="13"
		viewBox="0 0 13 13"
		fill="none"
	>
		<path
			d="M6.36397 7.77819L11.3137 12.7279L12.7279 11.3137L7.77819 6.36397L12.7279 1.41423L11.3137 1.1603e-05L6.36397 4.94976L1.41421 0L0 1.41421L4.94976 6.36397L1.18415e-05 11.3137L1.41423 12.7279L6.36397 7.77819Z"
			fill="white"
		/>
	</svg>
);
export const RotateIcon = () => (
	<svg
		xmlns="http://www.w3.org/2000/svg"
		width="24"
		height="24"
		viewBox="0 0 24 24"
		fill="currentColor"
	>
		<path
			d="M6.1443 6.15055C9.34843 2.94642 14.6518 2.94642 17.8559 6.15055L15.3147 8.69176H21.9439V2.06256L19.8446 4.16179C15.5357 -0.147191 8.46452 -0.147191 4.15554 4.16179C1.72485 6.59248 0.730475 9.90708 1.06193 13.1112H3.82408C3.49262 10.6805 4.26601 8.02884 6.1443 6.15055Z"
			fill="currentColor"
		/>
		<path
			d="M22.9366 10.9017H20.1745C20.5059 13.3324 19.7325 15.9841 17.8542 17.8624C14.6501 21.0665 9.34676 21.0665 6.14268 17.8624L8.68389 15.3212H2.05469V21.9504L4.15392 19.8512C8.4629 24.1601 15.4236 24.1601 19.7325 19.8512C22.2737 17.4205 23.2681 14.1059 22.9366 10.9017Z"
			fill="currentColor"
		/>
	</svg>
);

export const GridTwoColIcon = () => (
	<svg
		xmlns="http://www.w3.org/2000/svg"
		width="24"
		height="24"
		viewBox="0 0 24 24"
		role="img"
		aria-label="2x2 grid filled"
	>
		<rect x="3" y="3" width="8" height="8" rx="1" fill="currentColor" />
		<rect x="13" y="3" width="8" height="8" rx="1" fill="currentColor" />
		<rect x="3" y="13" width="8" height="8" rx="1" fill="currentColor" />
		<rect x="13" y="13" width="8" height="8" rx="1" fill="currentColor" />
	</svg>
);

export const GridThreeColIcon = () => (
	<svg
		xmlns="http://www.w3.org/2000/svg"
		width="24"
		height="24"
		viewBox="0 0 24 24"
		role="img"
		aria-label="3x3 grid filled"
	>
		<rect x="2" y="2" width="6" height="6" rx="1" fill="currentColor" />
		<rect x="9" y="2" width="6" height="6" rx="1" fill="currentColor" />
		<rect x="16" y="2" width="6" height="6" rx="1" fill="currentColor" />
		<rect x="2" y="9" width="6" height="6" rx="1" fill="currentColor" />
		<rect x="9" y="9" width="6" height="6" rx="1" fill="currentColor" />
		<rect x="16" y="9" width="6" height="6" rx="1" fill="currentColor" />
		<rect x="2" y="16" width="6" height="6" rx="1" fill="currentColor" />
		<rect x="9" y="16" width="6" height="6" rx="1" fill="currentColor" />
		<rect x="16" y="16" width="6" height="6" rx="1" fill="currentColor" />
	</svg>
);

export const HeartIcon = () => (
	<svg
		width="34"
		height="24"
		viewBox="0 0 20 20"
		fill="none"
		stroke="currentColor"
		strokeWidth="2"
		xmlns="http://www.w3.org/2000/svg"
	>
		<path
			d="M10 17.5l-1.45-1.32C4.4 12.36 2 10.28 2 7.5 2 5.42 3.42 4 5.5 4c1.54 0 3.04 1 3.57 2.36h1.87C11.46 5 12.96 4 14.5 4 16.58 4 18 5.42 18 7.5c0 2.78-2.4 4.86-6.55 8.68L10 17.5z"
			fill="none"
		/>
	</svg>
);
export const HeartIconFull = () => (
	<svg
		xmlns="http://www.w3.org/2000/svg"
		width="23"
		height="21"
		viewBox="0 0 23 21"
		fill="currentColor"
	>
		<path
			d="M20.2913 2.61183C19.7805 2.10083 19.1741 1.69547 18.5066 1.41891C17.8392 1.14235 17.1238 1 16.4013 1C15.6788 1 14.9634 1.14235 14.2959 1.41891C13.6285 1.69547 13.022 2.10083 12.5113 2.61183L11.4513 3.67183L10.3913 2.61183C9.3596 1.58013 7.96032 1.00053 6.50129 1.00053C5.04226 1.00053 3.64298 1.58013 2.61129 2.61183C1.5796 3.64352 1 5.04279 1 6.50183C1 7.96086 1.5796 9.36013 2.61129 10.3918L11.4513 19.2318L20.2913 10.3918C20.8023 9.88107 21.2076 9.27464 21.4842 8.60718C21.7608 7.93972 21.9031 7.22431 21.9031 6.50183C21.9031 5.77934 21.7608 5.06393 21.4842 4.39647C21.2076 3.72901 20.8023 3.12258 20.2913 2.61183Z"
			fill="currentColor"
			stroke="currentColor"
			strokeWidth="2"
			strokeLinecap="round"
			strokeLinejoin="round"
		/>
	</svg>
);
export const LibraryButtonIcon = () => (
	<svg
		xmlns="http://www.w3.org/2000/svg"
		width="20"
		height="20"
		viewBox="0 0 20 20"
		fill="none"
	>
		<rect width="20" height="20" rx="2.5" fill="white" />
		<path
			d="M3.5 11.6646C3.5 11.1037 3.95471 10.649 4.51562 10.649H8.33437C8.89529 10.649 9.35 11.1037 9.35 11.6646V15.4834C9.35 16.0443 8.89529 16.499 8.33437 16.499H4.51563C3.95471 16.499 3.5 16.0443 3.5 15.4834V11.6646Z"
			fill="#6F22DD"
		/>
		<path
			d="M10.65 6.42402C10.65 4.80859 11.9596 3.49902 13.575 3.49902C15.1904 3.49902 16.5 4.80859 16.5 6.42402C16.5 8.03946 15.1904 9.34902 13.575 9.34902C11.9596 9.34902 10.65 8.03946 10.65 6.42402Z"
			fill="#6F22DD"
		/>
		<path
			d="M3.5 4.51465C3.5 3.95373 3.95471 3.49902 4.51562 3.49902H8.33437C8.89529 3.49902 9.35 3.95373 9.35 4.51465V8.3334C9.35 8.89431 8.89529 9.34902 8.33437 9.34902H4.51563C3.95471 9.34902 3.5 8.89431 3.5 8.3334V4.51465Z"
			fill="#6F22DD"
		/>
		<rect
			x="10.6484"
			y="15.1989"
			width="5.85"
			height="0.866667"
			rx="0.433333"
			fill="#6F22DD"
		/>
		<rect
			x="10.6484"
			y="11.082"
			width="5.85"
			height="0.866667"
			rx="0.433333"
			fill="#6F22DD"
		/>
		<rect
			x="10.6484"
			y="13.0321"
			width="5.85"
			height="0.866667"
			rx="0.433333"
			fill="#6F22DD"
		/>
	</svg>
);

export const ImportIcon = () => (
	<svg
		xmlns="http://www.w3.org/2000/svg"
		width="16"
		height="16"
		viewBox="0 0 16 16"
		fill="none"
	>
		<path
			d="M7.37544 2C7.37544 1.65482 7.65526 1.375 8.00044 1.375C8.34562 1.375 8.62544 1.65482 8.62544 2V9.49121L11.5356 6.58105C11.7797 6.33698 12.1753 6.33698 12.4194 6.58105C12.6635 6.82513 12.6635 7.22077 12.4194 7.46484L8.44282 11.4424C8.19875 11.6865 7.80214 11.6865 7.55806 11.4424L3.5815 7.46484C3.33742 7.22077 3.33742 6.82513 3.5815 6.58105C3.82557 6.33698 4.22121 6.33698 4.46528 6.58105L7.37544 9.49121V2Z"
			fill="white"
		/>
		<path
			d="M1.375 13V10C1.375 9.65482 1.65482 9.375 2 9.375C2.34518 9.375 2.625 9.65482 2.625 10V13C2.625 13.2071 2.79289 13.375 3 13.375H13C13.2071 13.375 13.375 13.2071 13.375 13V10C13.375 9.65482 13.6548 9.375 14 9.375C14.3452 9.375 14.625 9.65482 14.625 10V13C14.625 13.8975 13.8975 14.625 13 14.625H3C2.10254 14.625 1.375 13.8975 1.375 13Z"
			fill="white"
		/>
	</svg>
);

export const ProBadgeIcon = () => (
	<svg
		xmlns="http://www.w3.org/2000/svg"
		width="16"
		height="16"
		viewBox="0 0 16 16"
		fill="none"
	>
		<path
			d="M10.2168 6.01685C10.4052 6.36235 10.7221 6.62112 11.1104 6.70239C11.5047 6.7848 11.908 6.66835 12.2129 6.38892C12.6721 5.96794 13.1316 5.54719 13.5908 5.12622C13.9105 4.83318 14.2301 4.53939 14.5498 4.24634C14.2969 6.25538 14.0439 8.26462 13.791 10.2737H2.22266C1.96972 8.26422 1.71583 6.25481 1.46289 4.24536C2.24239 4.9599 3.02238 5.67449 3.80176 6.38892C4.10679 6.66852 4.50974 6.785 4.9043 6.70239C5.29249 6.62111 5.60845 6.36227 5.79688 6.01685L8.00684 1.96509L10.2168 6.01685Z"
			stroke="white"
			strokeWidth="1.3545"
		/>
		<path
			d="M13.7234 14.8507H2.29045C1.92294 14.8507 1.625 14.4866 1.625 14.0374V12.2507H14.3889V14.0374C14.3888 14.4866 14.0909 14.8507 13.7234 14.8507Z"
			fill="currentColor"
		/>
	</svg>
);
// Preview Icon Component.
export const PreviewIcon = memo( () => (
	<>
		<i className="dashicons dashicons-visibility" />
		{ __( 'Live Preview', 'location-weather' ) }
	</>
) );

export const LocationWeatherLogo = ( { fill = '#f26c0d' } ) => (
	<svg
		width={ 24 }
		height={ 24 }
		viewBox="0 0 24 24"
		fill="none"
		xmlns="http://www.w3.org/2000/svg"
	>
		<g clipPath="url(#a)" fill={ fill }>
			<path d="M19.582 8.564c0-1.205-.49-2.288-1.28-3.051a4.31 4.31 0 0 0-5.29-.665 4.8 4.8 0 0 0-1.23 1.107l.026.026c.37.272.69.54.959.838.442.469.812.986 1.084 1.575.124 0 .271-.026.392-.026 1.33 0 2.511.54 3.399 1.404.098.098.196.223.294.321.295.344.54.763.714 1.182.245-.32.468-.69.615-1.057a4.3 4.3 0 0 0 .317-1.654m-4.307-5.539a.65.65 0 0 0 .638-.639V.638A.65.65 0 0 0 15.275 0a.65.65 0 0 0-.642.638v1.748c0 .344.298.639.642.639M20.1 4.648l1.232-1.23a.627.627 0 1 0-.888-.888l-1.23 1.23a.627.627 0 1 0 .887.888m3.123 3.3h-1.748a.65.65 0 0 0-.638.638.65.65 0 0 0 .638.639h1.748a.65.65 0 0 0 .638-.639c-.022-.343-.29-.638-.638-.638M20.1 12.525a.627.627 0 1 0-.887.887l1.231 1.231a.627.627 0 1 0 .888-.887zm-9.673-7.877a.627.627 0 1 0 .887-.887l-1.23-1.23c-.224-.273-.639-.273-.888 0a.627.627 0 0 0 0 .886zM13.474 17.8H1.485a.83.83 0 0 0 0 1.661h11.993c.91 0 1.65.737 1.65 1.647a1.244 1.244 0 1 1-2.489-.004.827.827 0 1 0-1.653 0A2.9 2.9 0 0 0 13.881 24a2.9 2.9 0 0 0 2.896-2.896 3.31 3.31 0 0 0-3.304-3.304" />
			<path
				fillRule="evenodd"
				clipRule="evenodd"
				d="M12.813 9.965a3.2 3.2 0 0 1 1.453-.321c.96 0 1.847.396 2.477 1.03a3.46 3.46 0 0 1 1.035 2.485c0 .96-.396 1.847-1.035 2.485a3.68 3.68 0 0 1-2.51 1.057h-11.2A2.94 2.94 0 0 1 .08 13.748a2.94 2.94 0 0 1 2.953-2.953c.12 0 .245-.022.343-.098a.61.61 0 0 0 .272-.442A4.76 4.76 0 0 1 5.25 7.352c.861-.714 1.945-1.156 3.127-1.156 1.012 0 1.944.321 2.734.861.615.397 1.11.96 1.503 1.65a1.6 1.6 0 0 0-.295.125 4.8 4.8 0 0 0-1.624 1.182.605.605 0 0 0 .05.887.604.604 0 0 0 .887-.049c.32-.396.74-.691 1.182-.887M3.149 15a1.35 1.35 0 1 0 0-2.7 1.35 1.35 0 0 0 0 2.7"
			/>
		</g>
		<defs>
			<clipPath id="a">
				<path fill="#fff" d="M0 0h24v24H0z" />
			</clipPath>
		</defs>
	</svg>
);
